import type { QueryClient } from '@tanstack/react-query';
import type { BookmarkCollectionResponse } from '../types/api';
import type { client } from './apiClient';

export type BookmarksParams = Parameters<typeof client.bookmarks>[0];

export function getHomeBookmarksParams(
  page = 1,
  sort?: 'newest' | 'oldest',
): BookmarksParams {
  return {
    section_type: 'home',
    page,
    sort: sort ?? getBookmarkListSortOrder(),
  };
}

export function getBookmarkListSortOrder(): 'newest' | 'oldest' {
  try {
    const saved = localStorage.getItem('ipt:preferences');
    if (saved) {
      const parsed = JSON.parse(saved) as {
        bookmarkList?: { sortOrder?: string };
      };
      const sort = parsed.bookmarkList?.sortOrder;
      if (sort === 'newest' || sort === 'oldest') {
        return sort;
      }
    }
  } catch {
    // Ignore malformed preferences
  }
  return 'newest';
}

export function seedBookmarksCache(
  queryClient: QueryClient,
  params: BookmarksParams,
  data: BookmarkCollectionResponse,
) {
  queryClient.setQueryData(['bookmarks', params], data);
}
